import React from "react";
import { TableHeaderColumnType } from "app/components/Table/types";
import { ListItem } from "./types";
import edit from "assets/ic_edit.svg";
import trash from "assets/ic_trash.svg";
import duplicate from "assets/duplicate.svg";

export const TableHeaderDefinition = {
  QUESTION_ID: {
    id: "_id", // "QUESTION_ID
    label: "QUESTION_ID",
    format: (value) => value,
    maxWidth: 110,
    minWidth: 110,
    sortable: false,
  },
  QUESTION_TYPE: {
    id: "type", // "QUESTION_TYPE
    label: "QUESTION_TYPE",
    format: (value) => value,
    maxWidth: 200,
    minWidth: 200,
    sortable: true,
  },
  QUESTION_BODY: {
    id: "body", // "QUESTION_BODY
    label: "QUESTION_BODY",
    format: (value) => value,
    maxWidth: 310,
    minWidth: 310,
    sortable: true,
  },
  QUESTION_NAME: {
    id: "name", // "QUESTION_NAME
    label: "QUESTION_NAME",
    format: (value) => value,
    maxWidth: 200,
    minWidth: 130,
    sortable: true,
  },
  EDITOR_NAME: {
    id: "user.fullName", // "EDITOR_NAME
    label: "EDITOR_NAME",
    format: (value) => value,
    maxWidth: 180,
    minWidth: 180,
    sortable: true,
  },
  CUSTOMER_NAME_EMAIL: {
    id: "user.fullName", // "EDITOR_NAME
    label: "CUSTOMER_NAME_EMAIL",
    format: (value) => value,
    maxWidth: 180,
    minWidth: 180,
    sortable: false,
  },
  TICKET: {
    id: "user.fullName", // "EDITOR_NAME
    label: "TICKET_ID",
    format: (value) => value,
    maxWidth: 180,
    minWidth: 180,
    sortable: false,
  },
  CREATED_DATE: {
    id: "createdAt", // "CREATED_DATE
    label: "CREATED_DATE",
    format: (value) => value,
    maxWidth: 160,
    minWidth: 160,
    sortable: true,
  },
  EDITED_DATE: {
    id: "updatedAt", // "EDITED_DATE
    label: "EDITED_DATE",
    format: (value) => value,
    maxWidth: 160,
    minWidth: 160,
    sortable: true,
  },
};

export const QuestionsTableHeaders: TableHeaderColumnType[] = Object.values(
  TableHeaderDefinition
).filter( f=>  !['CUSTOMER_NAME_EMAIL','TICKET_ID'].includes( f.label));;

export const CustomizedTableHeaders: TableHeaderColumnType[] = Object.values(
  TableHeaderDefinition
).filter( f=>  !['EDITOR_NAME', 'QUESTION_NAME'].includes(f.label));

  export const MenuOptions: ListItem[] = [
    {
      id: "1",
      name: "DUPLICATE",
      onClick: () => console.log("Download File"),
      icon: <img src={duplicate} alt="file" />,
    },
    {
      id: "2",
      name: "EDIT",
      onClick: () => console.log("Download Folder"),
      icon: <img src={edit} alt="folder" />,
    },
    {
      id: "3",
      name: "DELETE",
      onClick: () => console.log("Download Folder"),
      icon: <img src={trash} alt="controller" />,
    },
  ];
